import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import MediaCard from "@/components/feature/MediaCard";
import { getLatestMedia } from "@/lib/data";
import { typeLabels } from "@/lib/labels";
import type { MediaType } from "@/types";

const tabs: { key: "all" | MediaType; label: string }[] = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
  { key: "variety", label: "综艺" },
];

export default function LatestGrid() {
  const [tab, setTab] = useState<"all" | MediaType>("all");
  const [visible, setVisible] = useState(8);

  const all = getLatestMedia();
  const filtered = tab === "all" ? all : all.filter((m) => m.type === tab);
  const shown = filtered.slice(0, visible);

  return (
    <section className="bg-background-100/50">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
        <SectionHeading
          title="最新影视推荐"
          subtitle="每周更新的精选片单，点开卡片即可查看详情"
          icon="ri-fire-line"
          moreTo="/category/movie"
          moreLabel="浏览全部"
        />

        <div className="mb-6 flex flex-wrap gap-1 rounded-full border border-background-200/60 bg-background-50/60 p-1 w-fit">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => {
                setTab(t.key);
                setVisible(8);
              }}
              className={`rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                tab === t.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-400 hover:text-foreground-950"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4 lg:gap-6">
          {shown.map((item, i) => (
            <div key={item.id} className={`animate-fade-up delay-${(i % 4) + 1}`}>
              <MediaCard item={item} showType={tab === "all"} />
            </div>
          ))}
        </div>

        {shown.length < filtered.length && (
          <div className="mt-8 flex justify-center">
            <button
              type="button"
              onClick={() => setVisible((v) => v + 4)}
              className="flex items-center gap-2 rounded-md border border-background-300/70 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-foreground-950 cursor-pointer whitespace-nowrap"
            >
              加载更多
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>
        )}

        {filtered.length === 0 && (
          <p className="py-10 text-center text-sm text-foreground-400">
            该分类下暂无内容，试试切换其他标签。
          </p>
        )}
        <p className="mt-4 text-center text-xs text-foreground-300">
          当前展示 {shown.length} / {filtered.length} 部 · 分类：{tab === "all" ? "全部" : typeLabels[tab]}
        </p>
      </div>
    </section>
  );
}